import styled from 'styled-components';
var FillScreen = styled.div.withConfig({
  displayName: "FillScreen",
  componentId: "sc-18j83qe-0"
})(["z-index:1;width:100%;height:100%;position:fixed;top:0;left:0;display:flex;justify-content:center;align-items:center;pointer-events:none;& > *{pointer-events:auto;}"]);
export default FillScreen;